<template>
    <div class="loading-box">
        <div class="loading-item mb-1rem">
    
            <div class="rect animation mb-1rem"></div>
    
            <div class="mb-05rem">
                <div class="pill animation pill-title mb-1rem w-70"></div>
                <div class="pill animation pill-title mb-1rem w-50"></div>
                <div class="pill animation pill-title mb-1rem w-60"></div>
                <div class="pill animation pill-title mb-1rem w-55"></div>
            </div>
    
            <div class="display-flex-align-center w-55 mb-30px">
                <div class="pill animation pill-text mr-1rem flex-shrink"></div>
                <div class="pill-column pill-text animation mr-5px flex-shrink"></div>
                <div class="pill animation pill-text w-100"></div>
            </div>

            <div class="mb-1rem">
                <div class="pill animation pill-content mb-1rem w-55"></div>
                <div class="pill animation pill-content mb-1rem w-90"></div>
                <div class="pill animation pill-content mb-1rem w-50"></div>
                <div class="pill animation pill-content mb-1rem w-50"></div>
            </div>

            <div class="mb-48px">
                <div class="pill animation pill-content mb-1rem w-90"></div>
                <div class="pill animation pill-content mb-1rem w-100"></div>
                <div class="pill animation pill-content mb-1rem w-90"></div>
                <div class="pill animation pill-content mb-1rem w-70"></div>
            </div>

            <div class="mb-48px">
                <div class="pill animation pill-content mb-1rem w-30"></div>
            </div>

            <div>
                <div class="pill animation pill-content mb-1rem w-70"></div>
                <div class="pill animation pill-content mb-1rem w-80"></div>
                <div class="pill animation pill-content mb-1rem w-90"></div>
                <div class="pill animation pill-content mb-1rem w-80"></div>
                <div class="pill animation pill-content mb-1rem w-50"></div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingNews'
    }
</script>


<style scoped src="../../assets/css/loading/index.css"></style>